import API from "..";

export default class WorkRequestType {

  constructor({
    typeName,
    isActive
  }) 
    
  {
    this.typeName = typeName;
    this.isActive = isActive;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/workRequestType`);
    if (data.result) {
        return data.result.map((d) => new WorkRequestType(d));
    }
    else {
        return [];
    }
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/workRequestType`);
    if (data && data.result && data.result.length > 0) {
        return data.result.filter(r => r.isActive);
    }
    else {
        return [];
    }
  }
}
